<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>La canonización de Juan Diego</h2>
    <img @click="imageClicked(0)" src="galerias/guadalupe/g11/G11.jpg" class="mainphoto"/>
    <p class="photo-description">Virgen de Guadalupe y San Juan Diego. Autor: José de Ibarra. Óleo sobre tela, 1743. Col Catedral Metropolitana. Ciudad de México.</p>
    <p>El 31 de julio de 2002 el Papa Juan Pablo II canonizó a Juan Diego expresando en su homilía: “Con gran gozo he peregrinado hasta esta Basílica de Guadalupe, corazón mariano de México y de América, para proclamar la santidad de Juan Diego Cuauhtlatoatzin, el indio sencillo y humilde que contempló el rostro dulce y sereno de la Virgen del Tepeyac, tan querido por los pueblos de México”.</p>
    <p>A 490 años del Acontecimiento Guadalupano, la devoción a la Virgen es cada vez mayor, congregando a más de 7 millones de mexicanos cada 12 de diciembre, haciendo de la Basílica de Guadalupe en México el segundo Santuario católico más visitado después de la Basílica de San Pedro en Roma.</p>
    <h5>VER MÁS</h5>
    <p>
      <ul>
        <li><a target="_blank" href="http://www.vatican.va/content/john-paul-ii/es/homilies/2002/documents/hf_jp-ii_hom_20020731_canonization-mexico.html">www.vatican.va</a></li>
        <li><a target="_blank" href="https://www.ngenespanol.com/traveler/rompen-record-de-peregrinos-a-la-basilica-de-guadalupe/amp">www.ngenespanol.com</a></li>
      </ul>
    </p>

    <h4>La devoción a la Virgen de Guadalupe en el s.XXI</h4>
    <img @click="imageClicked(1)" class="mainphoto" src="galerias/guadalupe/g11/G11_A.jpg"/>
    <p class="photo-description">En la imagen se observa una entrega devocional a la Virgen de Guadalupe.</p>
    <p>En el siglo XXI “Guadalupe es México y México es Guadalupe” en palabras José Antonio Quintana Fernández. La Virgen de Guadalupe reúne todo lo bueno, no se puede entender la historia de nuestra Patria sin el Acontecimiento Guadalupano y su culto.</p>
    <p>Estudiosos como Fidel González Fernández, José Luis Guerrero Rosado, Eduardo Chávez Sánchez, Gustavo Watson Marrón, Arturo Rocha o Eugenio Urrutia siguen profundizando en el Acontecimiento Guadalupano desde prestigiosos centros de investigación como el Instituto Superior de Estudios Guadalupanos (ISEG), el Centro de Estudios Guadalupanos (UPAEP) y el Colegio de Estudios Guadalupanos (UIC).</p>
    <p>Si deseas conocer más:
      <ul>
        <li><a target="_blank" href="https://investigacion.upaep.mx/images/img/editorial_upaep/biblioteca_virtual/pdf/vgd_i.pdf">investigacion.upaep.mx</a></li>
        <li><a target="_blank" href="https://morenita.mx/index.html">morenita.mx</a></li>
        <li><a target="_blank" href="https://www.google.com/amp/s/www.nationalgeographicla.com/historia/2020/01/cada-ano-millones-de-peregrinos-visitan-la-ciudad-de-mexico-en-busca-de-milagros/amp">www.nationalgeographicla.com</a></li>
      </ul>
    </p>
    
    <h4>La Virgen de Guadalupe y el COVID-19</h4>
    <img @click="imageClicked(2)" class="mainphoto" src="galerias/guadalupe/g11/G11_B.jpg"/>
    <p>El 12 de abril del 2020, Domingo de Resurrección, se realizó la Consagración de América Latina y El Caribe a Nuestra Señora de Guadalupe para pedirle por la salud del mundo ante el COVID-19.</p>
    <p>La Virgen de Guadalupe es pasado, es presente y es futuro.</p>
    <p>Visita al Santuario Guadalupano. Año 2020. Fotografía de Carlo Echegoyen. Revista Animal Político.</p>
    <p>Si deseas conocer más:
      <ul>
        <li><a target="_blank" href="https://prensacelam.org/2020/04/11/12-de-abril-unase-a-la-consagracion-del-continente-a-la-virgen-de-guadalupe/">prensacelam.org</a></li>
      </ul>
    </p>
  </div>
</template>

<script>
export default {
  name: "Sala2m10",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
